











































































































	import { Component, Vue} from "vue-property-decorator";
	import TextHeader from "@/components/Common/TextHeader.vue";
	import SolarComponentsTable from "@/components/Solar/SolarComponentsTable.vue";
	import SolarCan from "@/components/Solar/SolarCan.vue";
	import SolarCanHome from '@/components/Solar/SolarCanHome.vue';
    import SolarCanHomeNet from '@/components/Solar/SolarCanHome2.vue';
	import SolarCanBottom from '@/components/Solar/SolarCan4.vue'

	@Component({
		components: {
		    TextHeader,
            SolarComponentsTable,
            SolarCan,
            SolarCanHome,
            SolarCanHomeNet,
            SolarCanBottom,
		}
	})
	export default class SolarPage extends Vue{


	}
